import sweetAlert from 'sweetalert2';
import FaraGostarDynamicHttp from '../api/FaraGostarDynamicHttp';
import { getLocaleMsg } from '../lngProvider';

function IsEmpty(obj: any) {
  return typeof obj === 'object' && Object.keys(obj).length === 0;
}

const FileType = (type: string) => {
  type = type.toLowerCase();
  switch (type) {
    case 'png':
    case 'image/png':
      return 'png.svg';
    case 'jpg':
    case 'jpeg':
    case 'jfif':
    case 'image/jpeg':
      return 'jpg.svg';
    case 'svg':
    case 'xml':
    case 'image/svg+xml':
      return 'svg.svg';
    case 'htm':
    case 'html':
    case 'txt':
    case 'text':
    case 'text/html':
      return 'html.svg';
    case 'pdf':
    case 'application/pdf':
      return 'pdf.svg';
    case 'mp3':
    case 'audio/mp3':
      return 'google-drive-image.svg';
    case 'wmv':
    case 'video/mp4':
    case 'mp4':
      return 'mp4.svg';
    case 'docx':
    case 'doc':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'doc.svg';
    case 'xls':
    case 'xlsx':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'xls.svg';
    case 'rar':
    case 'zip':
      return 'zip.svg';
    default:
      return 'file.svg';
  }
};

const ServerError = (description: string, dir: string) => {
  ShowError(description);
};

const ShowError = (errorMessage: string) => {
  const messages = getLocaleMsg();
  return sweetAlert.fire(
    messages['messages.errorOccurInServer'],
    errorMessage,
    'error',
  );
};

function removeItemFromArray(item: string, arr: string[]) {
  return arr.filter((c) => c !== item);
}

function appendItemToArray(item: string, arr: string[]) {
  if (!item) return [];
  return [...arr, item];
}

function syncArray(item: string, arr: string[]) {
  if (arr.includes(item)) {
    return removeItemFromArray(item, arr);
  }
  return appendItemToArray(item, arr);
}

async function webBodyTemplateRendering(
  letterCode: string | undefined,
  src: string,
  webTemplatePageId: number,
  signature: any,
  resultBlob: boolean,
  webLetterTemplateId?: number,
) {
  const errorResult = '';
  let objectUrl = '';

  try {
    const http = await FaraGostarDynamicHttp();
    const res = await http.get(src);

    let {
      htmlBody,
      cssUnique,
      imageSignatureUnique,
      footerUnique,
      headerImageUnique,
      backGroundUnique,
      qrBarcodeUnique,
      confidentialImageUnique,
      yearTextImageUnique,
    } = res.data; // html server data

    // css
    try {
      const cssConfig = {
        params: {
          letterCode: letterCode,
          headerUnique: headerImageUnique,
          footerUnique,
          backGroundUnique,
          imageSignatureUnique,
          qrCodeUnique: qrBarcodeUnique,
          confidentialImageUnique,
          cssUnique,
          yearTextImageUnique: yearTextImageUnique,
        },
      };

      const http = await FaraGostarDynamicHttp();

      const cssResult = await http.get('letterBody/getCssBody', cssConfig); // css server data

      let cssData = cssResult.data;

      // header, footer and backgroud

      const bgParams = {
        webTemplatePageId,
        webLetterTemplateId: webLetterTemplateId ? webLetterTemplateId : 0,
      };
      // header
      cssData = await insertBlobUrlIntoStr(
        bgParams,
        'letterBody/getHeader',
        cssData,
        headerImageUnique,
      );

      // footer
      cssData = await insertBlobUrlIntoStr(
        bgParams,
        'letterBody/getFooter',
        cssData,
        footerUnique,
      );
      // body
      cssData = await insertBlobUrlIntoStr(
        bgParams,
        'letterBody/getBackGround',
        cssData,
        backGroundUnique,
      );

      const cssBlob = new Blob([cssData], {
        type: 'text/css',
      });
      const cssBlobUrl = URL.createObjectURL(cssBlob);
      htmlBody = htmlBody.replace(cssUnique, cssBlobUrl);
    } catch (error) {
      console.log('css: ', error);
    }

    // img
    if (signature && signature.length > 0) {
      const signatureBodyParams = {
        letterCode: letterCode,
        employeeSignutureId: signature[0].employeePositionSignatureId,
      };
      htmlBody = await insertBlobUrlIntoStr(
        signatureBodyParams,
        'letterBody/getSignatureBody',
        htmlBody,
        imageSignatureUnique,
      );
    }
    if (resultBlob) {
      const BlobParts = [htmlBody];

      const blob = new Blob(BlobParts, {
        type: 'text/html',
        endings: 'transparent',
      });
      const objUrl = URL.createObjectURL(blob);
      objectUrl = objUrl;
    } else {
      objectUrl = htmlBody;
    }
  } catch (error) {
    console.log('server error: ', error);
  }
  return {
    errorResult: errorResult,
    objectUrl: objectUrl,
  };
}

async function insertBlobUrlIntoStr(
  params: any,
  route: string,
  str: string,
  uniqueKey: string,
) {
  try {
    const http = await FaraGostarDynamicHttp();
    const result = await http.get(route, {
      responseType: 'blob',
      params: params,
    });
    const blobUrl = URL.createObjectURL(result.data);
    return str.replace(uniqueKey, blobUrl);
  } catch (error) {
    console.log(error);
  }
}

function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor; //  || (window && window.opera)

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
}

export {
  FileType,
  ServerError,
  IsEmpty,
  ShowError,
  removeItemFromArray,
  appendItemToArray,
  syncArray,
  webBodyTemplateRendering,
  getMobileOperatingSystem,
};
